module.exports = __webpack_public_path__ + "img/letian.8ff334dc.png";